var map = {
	"./Automn-en.jpg": 367,
	"./Automn-fr.jpg": 1898,
	"./Summer-en.jpg": 930,
	"./Summer-fr.jpg": 7935,
	"./Winter-en.jpg": 2414,
	"./Winter-fr.jpg": 1219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3044;